import { render } from "./BreakageInfoDialog.vue?vue&type=template&id=245c4602&scoped=true"
import script from "./BreakageInfoDialog.vue?vue&type=script&lang=js"
export * from "./BreakageInfoDialog.vue?vue&type=script&lang=js"

import "./BreakageInfoDialog.vue?vue&type=style&index=0&id=245c4602&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245c4602"]])

export default __exports__